t = require('views/internal/teacup-with-helpers')('organization_list_item')

module.exports = ->
  t.a { href: t.mustacheVar('url') }, ->
    t.span '.item-name', ->
      t.text t.mustacheVar('displayName')
    t.mustacheBlock 'hasBusinessClass', ->
      t.icon 'business-class'
    t.span { class: 'icon-sm icon-' + t.mustacheVar('visIconClass') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/organization_list_item.coffee